import {  getAll, getById, remove, update } from "./baseService";

const testService = {
  getAllTests: () => {
    return getAll('tests')
  },
  getMyTests: () => {
    return getAll('tests/getMe')
  },
  getTestById: (test_id) => {
    return getById('tests',test_id)
  },
  updateTest: (test_id,test) => {
    return update('tests',test_id,test)
  },
  deleteTest: (test_id) => {
    return remove('tests',test_id)
  },
  getTestByCourseId: (test_id) => {
    return getById('tests/course',test_id)
  },


}

export default testService
